// @ts-check
const FOCUSABLE = 'button:not([disabled]), summary, a[href], input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])';

/** @param {Element} node @param {Element} scope */
function reachable(node, scope) {
  for (let current = /** @type {Element|null} */ (node); current && current !== scope.parentElement; current = current.parentElement) {
    if (current instanceof HTMLElement && (current.hidden || current.inert || current.hasAttribute('inert'))) return false;
    // A closed disclosure keeps only its own summary reachable.
    if (current !== node && current.tagName === 'DETAILS' && !current.hasAttribute('open') && !(node.tagName === 'SUMMARY' && node.parentElement === current)) return false;
  }
  return node.getAttribute('aria-hidden') !== 'true';
}

/** Move focus to the previous or next reachable control inside scope, wrapping at the ends.
 * Controllers have no Tab key; this is their Tab and Shift+Tab.
 * @param {Element} scope @param {-1|1} delta @returns {HTMLElement|null} the newly focused control
 */
export function walkFocus(scope, delta) {
  const nodes = [...scope.querySelectorAll(FOCUSABLE)].filter(/** @returns {node is HTMLElement} */ (node) => node instanceof HTMLElement && reachable(node, scope));
  const count = nodes.length;
  const active = scope.ownerDocument.activeElement;
  const start = active instanceof HTMLElement ? nodes.indexOf(active) : -1;
  for (let step = 1; step <= count; step++) {
    const index = start < 0 ? (delta > 0 ? step - 1 : count - step) : (((start + delta * step) % count) + count) % count;
    const next = /** @type {HTMLElement} */ (nodes[index]);
    if (next === active) break;
    next.focus({ preventScroll: false });
    // A stylesheet can hide a control (display: none) and focus() then leaves focus where it was.
    // Step past it instead of computing the same target on every press.
    if (scope.ownerDocument.activeElement === next) return next;
  }
  return null;
}
